import { ReactNode } from "react";

type PropType = {
  children: ReactNode;
}

export const Slide = (props: PropType) => {

  return (
    <div className="embla__slide flex-[0_0_100%] min-w-0 pl-[var(--slide-spacing)] !pointer-events-auto">
      {props.children}
    </div>
  )
}